@import 'styles/mixins';
@import 'styles/variables';

.tr {
  display: flex;
  align-items: flex-start;
  padding: 0 4px;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
  border-bottom: 1px solid $gray-5;

  &.md {
    min-height: 40px;
  }

  &.lg {
    min-height: 50px;
    padding: 10px 4px;
  }
}
